"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDependencyFieldValue = exports.getDependencyFieldEmptyValue = void 0;
const getDependencyFieldEmptyValue = () => {
    return { predecessor: [], successor: [] };
};
exports.getDependencyFieldEmptyValue = getDependencyFieldEmptyValue;
const generateDependencyFieldValue = (value) => {
    return { ...(0, exports.getDependencyFieldEmptyValue)(), ...value };
};
exports.generateDependencyFieldValue = generateDependencyFieldValue;
